import { Badge } from "@design";
import { Globe, Lock, Users } from "lucide-react";
import { useTranslation } from "react-i18next";
import type { WikiVisibility } from "./useWiki";

const ICON = { private: Lock, members: Users, org: Globe } as const;

/** Who can see a page. Neutral: visibility is information, not status. */
export function VisibilityBadge({ visibility }: Readonly<{ visibility: WikiVisibility }>) {
  const { t } = useTranslation("knowledge");
  const Icon = ICON[visibility];
  return (
    <Badge variant="neutral" size="compact" icon={<Icon size={12} aria-hidden />}>
      {t(`visibility.${visibility}`)}
    </Badge>
  );
}
